module.exports = __webpack_public_path__ + "img/Silvestri.2bef99ff.png";